import React, { Component, createRef } from "react";
import Header from "../After_Login_common/Header";
import Left_Sidebar from "../After_Login_common/Left_Sidebar";
import { userService } from "../../_services";
import { Redirect } from "react-router-dom";
//import CardPartial from './cardPartial';
import jsPDF from 'jspdf'
import domtoimage from 'dom-to-image';
import $ from 'jquery';
import OrderPage from "../Admin/Users/OrderPage";
//import PaymentForm from "../PaymentForm";
//import UpdatedTerms from "../Register/UpdatedTerms";
import CardFront from "../Summary/CardFront";
import CardBack from "../Summary/CardBack";
import FlyerPage1 from "./flyer1";
import FlyerPage2 from "./flyer2";
import FlyerLeft from '../../images/FlyerLeft.png'
import FlyerRight from '../../images/FlyerRight.png'
import closeIcon from '../../images/close.png';
import pdf1 from '../../resources/pricing-sheets/NuLifeSpan.Top.50.Walgreens.Mar25.pdf';
import pdf2 from '../../resources/pricing-sheets/NuLifeSpan.Top.CVS.Mar.25.pdf';
import pdf3 from '../../resources/pricing-sheets/NuLifeSpan.Walmart.top.Mar.25.pdf';

class OrderCardsPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            UserData: [],
            shortname: '',
            fullName: '',
            account_info: '',
            group_numbers: [],
            group_status: '',
            GroupData: '',
            selected_group: '',
            isPrimary: '',
            show_Payment_popup: false,
            show_Userdetail_popup: false,
            errorMsg: '',
            zoomRight: false,
            zoomLeft: false,
            pricingSheetData: []
        }
        this.iframeRefs = {
            pdf1: createRef(),
            pdf2: createRef(),
            pdf3: createRef(),
        }
        this.printAll = this.printAll.bind(this);
        this.downloaddocall = this.downloaddocall.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.toggle_user_detail = this.toggle_user_detail.bind(this);
        this.updateGroup = this.updateGroup.bind(this);
        this.selectedGroupData = this.selectedGroupData.bind(this)
        this.printIndivisual = this.printIndivisual.bind(this);
        this.downloaddoc = this.downloaddoc.bind(this);
    }

    componentDidMount() {
        try {
            let Usermeta_Data = window.atob(localStorage.getItem('ajs_user_id'));
            let usernamedata = window.atob(localStorage.getItem('hacker_user_detail'));
            this.setState({ shortname: usernamedata.split(':')[0], fullName: usernamedata.split(':')[1] });
            let userinfo = window.atob(localStorage.getItem('_file_info'));
            this.setState({ account_info: userinfo });
            this.GetUserGroups(Usermeta_Data.split(':')[0], Usermeta_Data.split(':')[1]);
            //this.GetUserCardSetting(Usermeta_Data.split(':')[0], Usermeta_Data.split(':')[1]);
            document.addEventListener('click', this.handleOutsideClick);
            document.addEventListener('keydown', this.handleKeyDown);
            this.getPricingSheets(Usermeta_Data.split(':')[0]);
            //const cardsData = this.getCardsData();
            //this.setState({ cardsData });
        }
        catch {
            this.logout();
        }
    }
    componentWillUnmount() {
        document.removeEventListener('click', this.handleOutsideClick);
        document.removeEventListener('keydown', this.handleKeyDown);
    }
    toggle_user_detail = (e) => {
        $('body').removeClass('payment-popup-active');
        e.stopPropagation();
        this.setState({ show_Userdetail_popup: !this.state.show_Userdetail_popup });
        this.setState({ show_Payment_popup: !this.state.show_Payment_popup });
    }

    handleClick = (e) => {
        this.setState({ show_Payment_popup: true });
        $('body').addClass('payment-popup-active');
    }
    printAll(event) {

        //var originalContents = document.body.innerHTML;
        // document.body.innerHTML = printableElements;
        //window.print();
        //document.body.innerHTML = originalContents;
        $('.printFlyers').css('display', 'block')
        $('.flyers').css('display', 'none')
        $('.pricing-sheets').css('display', 'none')
        $('.printFlyers').addClass('is-printing');
        $('.zoomedFlyerBox').addClass('is-printing');
        var printableElements = document.querySelector('.all_cards');
        printableElements.style.padding = 0;
        let flyerBoxes = document.querySelectorAll('.zoomedFlyerBox');
        flyerBoxes.forEach((el) => {
            el.style.maxHeight = 'none'
            el.style.overflow = 'unset'
        })
        var printHtml = printableElements.outerHTML
        document.body.innerHTML = printHtml;
        window.print()
        window.location.reload()
    }
    downloaddocall(event) {
        let ids = [];
        $('.contentarea .content_sec .card_page_content .cards').each(function () {
            let idattr = $(this).attr('id');
            ids.push(idattr);
        });
        ids.push('flyer1', 'flyer2');

        $('.flyers').css('display', 'none');
        $('.buttons').hide();
        $('.printFlyers').css('display', 'block');
        $('.printFlyers').addClass('is-downloading');

        const downloadPromises = ids.map((key) => {
            return domtoimage.toPng(document.getElementById(key))
                .then(function (blob) {
                    return new Promise((resolve, reject) => {
                        const pdf = new jsPDF("p", "mm", "a4");
                        const pdfWidth = pdf.internal.pageSize.getWidth();
                        const pdfHeight = pdf.internal.pageSize.getHeight();
                        const img = new Image();
                        img.src = blob;

                        img.onload = function () {
                            const imgWidth = img.width;
                            const imgHeight = img.height;

                            // Maintain aspect ratio
                            const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
                            const scaledWidth = imgWidth * ratio;
                            const scaledHeight = imgHeight * ratio;

                            // Center the image horizontally if necessary
                            const xOffset = (pdfWidth - scaledWidth) / 2;
                            const yOffset = (pdfHeight - scaledHeight) / 2;

                            pdf.addImage(blob, 'JPEG', xOffset, yOffset, scaledWidth, scaledHeight);

                            pdf.save(key + '.pdf');
                            resolve();
                        };

                        img.onerror = reject;
                    });
                });
        });

        // Reset UI once all downloads are complete
        Promise.all(downloadPromises)
            .then(() => {
                $('.printFlyers').css('display', 'none');
                $('.flyers').css('display', 'flex');
                $('.buttons').show();
                console.log('All flyers downloaded and UI reset.');
            })
            .catch((error) => {
                console.error('Error while downloading flyers:', error);
            });
        [pdf1, pdf2, pdf3].forEach((pdfUrl, index) => {
            setTimeout(() => {
                this.handleDownload(pdfUrl);
            }, index * 500); // Delay each download slightly to prevent browser blocking
        });
    }

    GetUserGroups(UserId, UserName) {
        userService.GetUserGroups(UserId, UserName)
            .then(apidata => {
                this.setState(
                    {
                        group_numbers: apidata,
                        selected_group: apidata[0].groupnumber,
                        group_status: apidata[0].status,
                        isPrimary: apidata[0].isPrimary
                    },
                    () => {
                        // Ensuring getCardsData runs after state is updated
                        const cardsData = this.getCardsData();
                        this.setState({ cardsData });
                    }
                );
                this.selectedGroupData(apidata[0].groupnumber);
            });
    }


    async updateGroup(e) {
        let group_no = e.target.value
        await this.selectedGroupData(group_no)
        this.setState({ selected_group: group_no })
    }
    selectedGroupData(seldata) {
        let sgd = this.state.group_numbers.filter((item) => {
            return item.groupnumber === seldata ? item : null
        })
        this.setState({ GroupData: sgd[0], isPrimary: sgd[0].isPrimary })
    }
    printIndivisual(event, id) {
        if (id === 'flyer1' || id === 'flyer2') {
            $('.printFlyers').css({ display: 'block' });
            $('.printFlyers').addClass('is-printing');
            $('.zoomedFlyerBox').addClass('is-printing');
            var printableElements = document.getElementById(id).outerHTML;
            document.body.innerHTML = printableElements;
        } else {
            var printableElements = document.getElementById(event.target.parentElement.nextElementSibling.getAttribute('id')).outerHTML;
            document.body.innerHTML = printableElements;
        }
        setTimeout(() => {
            window.print();
            window.location.reload()
        }, 3000)
    }
    downloaddoc(id, name, event) {
        if (id === 'flyer1' || id === 'flyer2') {
            $('.buttons').hide();
            $('.printFlyers').css({ display: 'block', marginTop: '100px' });
            $('.printFlyers').addClass('is-downloading');
            domtoimage.toPng(document.getElementById(id))
                .then(function (blob) {
                    var doc = new jsPDF("p", "mm", "a4"); // Portrait mode
                    var pdfWidth = doc.internal.pageSize.getWidth();
                    var pdfHeight = doc.internal.pageSize.getHeight();

                    var fixedWidth = pdfWidth - 20; // Keep margins

                    var img = new Image();
                    img.src = blob;
                    img.onload = function () {
                        var imgWidth = img.width;
                        var imgHeight = img.height;

                        // Maintain aspect ratio
                        var fixedHeight = (imgHeight / imgWidth) * fixedWidth;

                        // If the image height is greater than the page, scale it down
                        if (fixedHeight > pdfHeight - 20) {
                            var scaleFactor = (pdfHeight - 20) / fixedHeight;
                            fixedWidth = fixedWidth * scaleFactor;
                            fixedHeight = fixedHeight * scaleFactor;
                        }

                        // If the content still does not fit, split into multiple pages
                        var y = 10; // Top margin
                        if (fixedHeight > pdfHeight - 20) {
                            var totalPages = Math.ceil(fixedHeight / (pdfHeight - 20));
                            var chunkHeight = (pdfHeight - 20);

                            for (var i = 0; i < totalPages; i++) {
                                var yOffset = -i * chunkHeight;
                                if (i > 0) doc.addPage();
                                doc.addImage(blob, 'JPEG', 10, y + yOffset, fixedWidth, fixedHeight);
                            }
                        } else {
                            doc.addImage(blob, 'JPEG', 10, y, fixedWidth, fixedHeight);
                        }

                        doc.save(id + '.pdf');
                        $('.buttons').show();
                        $('.printFlyers').css({ display: 'none', marginTop: '0' });
                        $('.printFlyers').removeClass('is-downloading');
                    };
                });
        } else {
            domtoimage.toPng(document.getElementById(id))
                .then(function (blob) {
                    var doc = new jsPDF("l", "mm", "a4");
                    var width = doc.internal.pageSize.getWidth();
                    var height = doc.internal.pageSize.getHeight();
                    if (window.screen.width <= 1024 && window.screen.width > 575) {
                        doc.addImage(blob, 'JPEG', 10, 10, width / 1.5, height - 10);
                    } else if (window.screen.width <= 575) {
                        doc.addImage(blob, 'JPEG', 10, 10, width / 2.2, height);
                    } else {
                        doc.addImage(blob, 'JPEG', 10, 10, width - 20, height / 2.2);
                    }
                    doc.save(name + '.pdf');
                });
        }
    }
    GetUserCardSetting(UserId, UserName) {
        this.setState({ loader: true })
        try {
            userService.UserSetting(UserName, UserId)
                .then(
                    apidata => {
                        if (apidata.length > 0) {
                            if (apidata[0].code !== '-1') {
                                this.setState({ SuccessMessage: false, loader: false, cardSetting: apidata[0].cardSetting });
                            } else {
                                this.setState({ SuccessMessage: false, loader: false, errorMsg: apidata[0].message });
                            }
                        }
                    }
                );
        }
        catch (error) {
            this.setState({ loader: false })
        }
    }
    handleOutsideClick = (event) => {
        if (event.target.classList.contains("zoomed-flyer") && !event.target.closest('#flyer1') && !event.target.closest('#flyer2')) {
            if (this.state.zoomLeft || this.state.zoomRight) {
                this.setState({ zoomLeft: false, zoomRight: false });
            }
        }
    };

    handleKeyDown = (event) => {
        if (event.key === 'Escape') {
            this.setState({ zoomLeft: false, zoomRight: false });
        }
    };
    getCardsData = () => {
        const userRole = window.atob(localStorage.getItem('UserRole'));
        const { group_status } = this.state;
        let cardsData = [{
            cardname: 'Glic Card',
            classnames: 'glic_card',
            bin: '023518',
            pcn: 'ARX',
        }];

        if (group_status === 'Yes') {
            cardsData.push(
                {
                    cardname: 'Citizen Card',
                    classnames: 'citizen_card',
                    bin: '015284',
                    pcn: 'CRX'
                },
                {
                    cardname: 'NVT Card',
                    classnames: 'nvt_card',
                    bin: '610602',
                    pcn: 'NVT'
                },
                {
                    cardname: 'CVS Card',
                    classnames: 'cvs_card',
                    bin: '610398',
                    pcn: 'CV1'
                },
                {
                    cardname: 'DST Card',
                    classnames: 'dst_card',
                    bin: '600428',
                    pcn: 'HRX'
                }
            );
        }

        return cardsData.map((card) => {
            let datetime = Math.floor(Math.random() * 1313131);
            let mId = (card.classnames === 'cvs_card' || card.classnames === 'walmart_card')
                ? `AX${datetime}`
                : userRole === 'consumer'
                    ? '100-4542'
                    : `AX${datetime}`;

            return { ...card, mId };
        });
    };
    handlePrint = (pdfKey) => {
        if (this.iframeRefs[pdfKey].current) {
            this.iframeRefs[pdfKey].current.contentWindow.focus();
            this.iframeRefs[pdfKey].current.contentWindow.print();
        }
    }
    handleDownload = (pdfUrl) => {
        const link = document.createElement("a");
        link.href = pdfUrl;
        link.download = pdfUrl.split("/").pop();
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    getPricingSheets(UserId) {
        try {
            userService.FetchPricingSheets(UserId).then((apiData) => {
                if (apiData && apiData.length > 0) {
                    this.setState({ pricingSheetData: apiData });
                }
            })
        } catch (err) {
        }
    }
    render() {
        let { group_numbers } = this.state;
        let userRole = window.atob(localStorage.getItem('UserRole'));
        let cardsData = [
            {
                cardname: 'Glic Card',
                classnames: 'glic_card',
                bin: '023518',
                pcn: 'ARX',
            }];
        if (this.state.group_status === 'Yes') {
            cardsData = [{
                cardname: 'Glic Card',
                classnames: 'glic_card',
                bin: '023518',
                pcn: 'ARX',
            },
            {
                cardname: 'Citizen Card',
                classnames: 'citizen_card',
                bin: '015284',
                pcn: 'CRX'
            },
            //{
            //    cardname: 'Walmart Card',
            //    classnames: 'walmart_card',
            //    bin: '610396',
            //    pcn: 'WM1'
            //},
            {
                cardname: 'NVT Card',
                classnames: 'nvt_card',
                bin: '610602',
                pcn: 'NVT'
            },
            {
                cardname: 'CVS Card',
                classnames: 'cvs_card',
                bin: '610398',
                pcn: 'CV1'
            },
            {
                cardname: 'DST Card',
                classnames: 'dst_card',
                bin: '600428',
                pcn: 'HRX'
            }];
        }
        if (userService.Check_Null_Empty(localStorage.getItem("ajs_user_id")) === true) return <Redirect to="/signup" />
        /* if (userService.Check_Null_Empty(localStorage.getItem("ajs_user_id")) != true && this.state.account_info != 0) return <Redirect to="/account" />*/
        localStorage.setItem('pagename', 'ordercard');

        return (window.atob(localStorage.getItem('UserRole')) == "Distributor" ?
            <div>
                {
                    (this.state.selected_group === null || this.state.selected_group === "" || this.state.selected_group === undefined) ?
                        null :
                        <div className="Dashboard_Area">
                            <Left_Sidebar Activemenu="4" account_info={this.state.account_info} fullName={this.state.fullName} />
                            <div className="contentarea">
                                <Header shortName={this.state.shortname} fullName={this.state.fullName} userRole="" />
                                <div className="content_sec">
                                    <div className="Card_Page_header">
                                        <div className="h2_title">
                                            <h2>Marketing Materials</h2>
                                            <p>The assets below are your personal cards and flyers to print and share.</p>
                                        </div>
                                        <div className="buttons_area AddPayment marketing-buttons_area">
                                            <div className="button" onClick={this.downloaddocall.bind(this)}>Download All</div>
                                            <div className="button" onClick={this.printAll.bind(this)}>Print All</div>
                                            {/*<div className="button cart-button" onClick={this.handleClick.bind(this)}>Shop Now <CartIcon /></div>*/}
                                            {/*<div className="button red"><a href="https://www.rxhacker.supply/" target="_blank">Order Printed Cards</a></div>*/}
                                            {/*<div className="button red" onClick={this.handleClick.bind(this)}>Get Your Starter Kit</div>*/}
                                        </div>
                                    </div>
                                    <div className="card_page_content marketing-materials">
                                        <div className="all_cards">
                                            <div className="select_group">
                                                <select onChange={this.updateGroup} value={this.state.selected_group} className="tt_select">
                                                    {
                                                        group_numbers.map((card, index) =>
                                                            <option key={index} value={card.groupnumber}>{card.groupnumber}</option>
                                                        )
                                                    }
                                                </select>
                                            </div>
                                            {
                                                this.state.cardsData ? this.state.cardsData.map((card, index) => {
                                                    /*let mId;
                                                    let datetime = Math.floor(Math.random() * 1313131);
                                                    let userGroup = this.state.GroupData.groupnumber;
                                                    if (card && card.classnames === 'cvs_card') {
                                                        mId = "AX" + datetime;
                                                    } else if (card && card.classnames === 'walmart_card') {
                                                        mId = "AX" + datetime;
                                                    } else {
                                                        mId = userRole === 'consumer' ? '100-4542' : "AX" + datetime;
                                                    }
                                                    card.mId = mId;*/
                                                    return (
                                                        <div key={index}>
                                                            <h3>{card.cardname}</h3>
                                                            <div className="buttons">
                                                                <div className="download" onClick={this.downloaddoc.bind(this, card.pcn + "_" + this.state.GroupData.groupnumber + index, card.pcn + "_" + this.state.GroupData.groupnumber)}></div>
                                                                <div className="print" onClick={this.printIndivisual.bind(this)}></div>
                                                            </div>
                                                            <div className={'cards ' + card.classnames} id={card.pcn + "_" + this.state.GroupData.groupnumber + index}>
                                                                <CardFront cardData={card} groupData={this.state.GroupData} />
                                                                <CardBack cardData={card} mId={card.mId} groupData={this.state.GroupData} groupNumber={this.state.GroupData.groupnumber} />
                                                            </div>
                                                            <div class={cardsData.length - 1 === index ? 'pagebreak hide' : 'pagebreak'}> </div>
                                                        </div>
                                                    )
                                                }) : null
                                            }
                                            <div className="nonPrintable"><h3 style={{ marginBottom: '10px' }}>Printable Flyers</h3></div>
                                            <div className="flyers">
                                                <div className="flyerPage">
                                                    <div className="buttons">
                                                        <div className="download" onClick={this.downloaddoc.bind(this, 'flyer2')}></div>
                                                        <div className="print" onClick={this.printIndivisual.bind(this, '', 'flyer2')}></div>
                                                    </div>
                                                    <div className="flyerBox" onClick={(e) => {
                                                        e.stopPropagation();
                                                        this.setState({ zoomRight: true });
                                                    }}>
                                                        <img src={FlyerRight} />
                                                    </div>
                                                    {this.state.zoomRight ? <div className="zoomed-flyer">
                                                        <div className="close" onClick={() => this.setState({ zoomRight: false })}>
                                                            <img src={closeIcon} alt="Close" />
                                                        </div>
                                                        <FlyerPage2 bin='023518' pcn='ARX' groupData={this.state.GroupData} groupNumber={this.state.GroupData.groupnumber} classnames='glic_card' mId={this.state.cardsData ? this.state.cardsData[0].mId : ''} />
                                                    </div> : null}
                                                </div>
                                                <div className="flyerPage">
                                                    <div className="buttons">
                                                        <div className="download" onClick={this.downloaddoc.bind(this, 'flyer1')}></div>
                                                        <div className="print" onClick={this.printIndivisual.bind(this, '', 'flyer1')}></div>
                                                    </div>
                                                    <div className="flyerBox" onClick={(e) => {
                                                        e.stopPropagation();
                                                        this.setState({ zoomLeft: true });
                                                    }}>
                                                        <img src={FlyerLeft} />
                                                    </div>
                                                    {this.state.zoomLeft ? <div className="zoomed-flyer">
                                                        <div className="close" onClick={() => this.setState({ zoomLeft: false })}>
                                                            <img src={closeIcon} alt="Close" />
                                                        </div>
                                                        <FlyerPage1 bin='023518' pcn='ARX' groupData={this.state.GroupData} groupNumber={this.state.GroupData.groupnumber} classnames='glic_card' mId={this.state.cardsData ? this.state.cardsData[0].mId : ''} />
                                                    </div> : null}
                                                </div>
                                            </div>
                                            <div className="nonPrintable"><h3 style={{ marginBottom: '10px' }}>Pricing Sheets</h3></div>
                                            <div className="pricing-sheets">
                                                {/* PDF 1 */}
                                                {this.state.pricingSheetData && this.state.pricingSheetData.length ? this.state.pricingSheetData.map((item, index) => <>
                                                    <div className="buttons">
                                                        <div className="download" onClick={() => this.handleDownload(item.filePath)}></div>
                                                        <div className="print" onClick={() => this.handlePrint(`pdf${index + 1}`)}></div>
                                                    </div>
                                                    <div className="sheet" onClick={() => window.open(item.filePath, "_blank", "noopener,noreferrer")}>
                                                        <iframe
                                                            ref={this.iframeRefs[`pdf${index + 1}`]}
                                                            src={item.filePath + "#toolbar=0&navpanes=0&scrollbar=0"}
                                                            width="100%"
                                                            height="300px"
                                                            title={item.fileName}
                                                        />
                                                    </div>
                                                </>) : null}

                                                {/* PDF 2 
                                                <div className="buttons">
                                                    <div className="download" onClick={() => this.handleDownload(pdf2)}></div>
                                                    <div className="print" onClick={() => this.handlePrint("pdf2")}></div>
                                                </div>
                                                <div className="sheet" onClick={() => window.open(pdf2, "_blank", "noopener,noreferrer")}>
                                                    <iframe
                                                        ref={this.iframeRefs.pdf2}
                                                        src={pdf2 + "#toolbar=0&navpanes=0&scrollbar=0"}
                                                        width="100%"
                                                        height="300px"
                                                        title="NuLifeSpan Top CVS Mar25"
                                                    />
                                                </div>*/}

                                                {/* PDF 3 
                                                <div className="buttons">
                                                    <div className="download" onClick={() => this.handleDownload(pdf3)}></div>
                                                    <div className="print" onClick={() => this.handlePrint("pdf3")}></div>
                                                </div>
                                                <div className="sheet" onClick={() => window.open(pdf3, "_blank", "noopener,noreferrer")}>
                                                    <iframe
                                                        ref={this.iframeRefs.pdf3}
                                                        src={pdf3 + "#toolbar=0&navpanes=0&scrollbar=0"}
                                                        width="100%"
                                                        height="300px"
                                                        title="NuLifeSpan Walmart top Mar25"
                                                    />
                                                </div>*/}
                                            </div>
                                            <div className="printFlyers" style={{ display: "none" }}>
                                                <div class="page-break"></div>
                                                <FlyerPage1 bin='023518' pcn='ARX' groupData={this.state.GroupData} groupNumber={this.state.GroupData.groupnumber} classnames='glic_card' mId={this.state.cardsData ? this.state.cardsData[0].mId : ''} />
                                                <div class="page-break"></div>
                                                <FlyerPage2 bin='023518' pcn='ARX' groupData={this.state.GroupData} groupNumber={this.state.GroupData.groupnumber} classnames='glic_card' mId={this.state.cardsData ? this.state.cardsData[0].mId : ''} />
                                            </div>
                                        </div>
                                    </div>
                                    {/*<div className="card_page_content">
                                    {group_numbers.map((card, index) =>
                                        <CardPartial key={index}  {...card}/>
                                    )}
                                </div>*/}
                                    <div>
                                        <div className="Account_info_form_parent order_cards_form">
                                            {this.state.show_Payment_popup === true ? (
                                                <div className="resetgroup_box">
                                                    <OrderPage toggle_user_detail={this.toggle_user_detail.bind(this)} forCard={true} groupNumbers={group_numbers} />
                                                </div>
                                            ) : null}
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                }
            </div> : <Redirect to="/page-not-found" />
        );
    }
}
export default OrderCardsPage;
